import React, { useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";

import $ from "jquery";
import routes from "../../routes";
import { updateCurrentStep } from "../../store/actions/order";

const Navbar = ({ location }) => {
  const usePrevious = value => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  };
  const prevLocation = usePrevious(location);

  const pages = ["Get Started", "Template", "Guestlist", "Finish Order"];

  const maxStep = useSelector(({ order }) => Number(order.maxStep));
  const dispatch = useDispatch();

  useEffect(() => {
    if (location !== prevLocation) {
      let step = 1;
      switch (location.pathname) {
        case routes.getstarted:
          step = 1;
          break;
        case routes.template:
          step = 2;
          break;
        case routes.guestlist:
          step = 3;
          break;
        case routes.order:
          step = 4;
          break;
        default:
          step = 1;
      }
      dispatch(updateCurrentStep(step));
    }
  }, [location]);

  useEffect(() => {
    if ($) {
      $('[data-toggle="true"]')
        .tooltip()
        .attr(
          "data-original-title",
          `You need to complete the ${pages[maxStep - 1]} step first`
        )
        .attr("data-placement", "bottom");
      $('[data-toggle="false"]').tooltip("dispose");
    }
  }, [maxStep]);

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <a className="navbar-brand" href="/">
        Send the Date
      </a>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNav"
        aria-controls="navbarNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>
      <div className="collapse navbar-collapse" id="navbarNav">
        <ul className="navbar-nav text-center ml-auto">
          <li className="nav-item">
            <NavLink className="nav-link" exact to="/">
              Get Started
            </NavLink>
          </li>
          <li className="nav-item d-none d-lg-block">
            <span className="nav-link">></span>
          </li>
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="/template"
              data-toggle={maxStep < 2}
            >
              Template
            </NavLink>
          </li>
          <li className="nav-item d-none d-lg-block">
            <span className="nav-link">></span>
          </li>
          <li className="nav-item">
            <NavLink
              className="nav-link"
              to="/guestlist"
              data-toggle={maxStep < 3}
            >
              Guestlist
            </NavLink>
          </li>
          <li className="nav-item d-none d-lg-block">
            <span className="nav-link">></span>
          </li>
          <li className="nav-item">
            <NavLink className="nav-link" to="/order" data-toggle={maxStep < 4}>
              FINISH ORDER
            </NavLink>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default withRouter(Navbar);
